
export const ApiUrl = `${process.env.REACT_APP_API}/api`;
    // "http://localhost:4000/"